<div *ngIf="!isIntervenant" class="row g-0 px-5 my-5">
	<div class="row g-0 mb-1" [ngClass]="'row-cols-6'">
		<div
			class="border border-light border-5 rounded bg-light row mx-4 g-0 align-items-center justify-content-center">
			<div class="col-10 theme-main-color fs-5 d-flex justify-content-center text-center">
				Bénéficiaires: {{ nbBeneficiaire }}
			</div>
		</div>
		<div
			class="border border-light border-5 rounded bg-light row mx-4 g-0 align-items-center justify-content-center">
			<div class="col-10 theme-main-color fs-5 d-flex justify-content-center text-center">
				Prestations ouvertes: {{ nbPrestationOuvert }}
			</div>
		</div>
		<div
			class="border border-light border-5 rounded bg-light row mx-4 g-0 align-items-center justify-content-center">
			<div class="col-10 theme-main-color fs-5 d-flex justify-content-center text-center">
				Prestations en cours: {{ nbPrestationEnCours }}
			</div>
		</div>
		<div
			class="border border-light border-5 rounded bg-light row mx-4 g-0 lign-items-center justify-content-center">
			<div class="col-10 theme-main-color fs-5 d-flex justify-content-center text-center">
				Prestations annulées: {{ nbPrestationAnnulees }}
			</div>
		</div>
		<div
			class="border border-light border-5 rounded bg-light row mx-4 g-0 align-items-center justify-content-center">
			<div class="col-10 theme-main-color fs-5 d-flex justify-content-center text-center">
				Prestations clôturées: {{ nbPrestationCloturees }}
			</div>
		</div>
	</div>
</div>
<div *ngIf="!isIntervenant" class="row g-0 px-5 my-5">
	<div class="row g-0 px-4 my-5">
		<div
			class="border border-light border-5 col-lg-12 rounded bg-light row g-0 align-items-center justify-content-center">
			<div echarts [options]="chartOptionDetailsPrestation" (chartInit)="onChartInit($event)"></div>
		</div>
		<!-- <div
			class="border border-light border-5 col-lg-12 rounded bg-light row g-0 align-items-center justify-content-center">
			<div echarts [options]="chartOptionChart1"></div>
		</div>
		<button class="btn btn-primary" (click)="exportChartAsImage()">
			Télécharger le graphique
		  </button> -->
	</div>

	<div *ngFor="
			let bdc of bdcList; index as i" class="row g-0 px-4 my-5" [ngClass]="'row-cols-4'">
		<div
			class="border border-light border-5 col-lg-3 rounded bg-light row g-0 align-items-center justify-content-center">
			<div echarts [options]="chartsBdc[i]"></div>
		</div>
		<ng-container *ngIf="bdc.references.length > 1 && chartsBdcReferences[i]">
			<div *ngFor="let bdcReference of bdc.references; index as j"
				class="border border-light border-5 col-lg-3 rounded bg-light row g-0 align-items-center justify-content-center">
				<div echarts [options]="chartsBdcReferences[i][j]"></div>
			</div>
		</ng-container>
	</div>

</div>